import { apiRequest } from "../api";
import { useState, useEffect } from "react";
import { Tip } from "../types/dbTypes";

export const useTips = () => {
  const [ignoredTips, setIgnoredTips] = useState<string[]>(
    JSON.parse(localStorage.getItem("ignored_tips") || "[]")
  );
  const ignoreTipForever = async (tipId: string) => {
    setIgnoredTips((prev) => {
      return prev ? [...prev, tipId] : [tipId];
    });

    apiRequest({
      method: "POST",
      subRoute: "user",
      path: "/ignore_tip",
      body: { tip_id: tipId }
    });
  };

  const ignoreTipSession = (tipId: string) => {
    sessionStorage.setItem(tipId, "1");
  };

  const isTipIgnored = (tipId: string) => {
    return sessionStorage.getItem(tipId) === "1" || ignoredTips.includes(tipId);
  };

  useEffect(() => {
    apiRequest<Tip[]>({ subRoute: "user", path: "/tips" }).then((data) =>
      setIgnoredTips(data.map((t) => t.tip_id))
    );
  }, []);

  useEffect(() => {
    if (!!ignoredTips) {
      localStorage.setItem("ignored_tips", JSON.stringify(ignoredTips));
    }
  }, [ignoredTips]);

  return {
    ignoreTipForever,
    ignoreTipSession,
    isTipIgnored
  };
};
